import cn from "./cn";

/**
 * Kartu KPI — spesifikasi .widget Design System KLH/BPLH v2.1.
 * Nilai memakai font display 1.85rem/800, ikon dalam kotak 42px radius 11px,
 * dan tren berwarna --success / --danger.
 */
export default function StatWidget({
  value,
  caption,
  icon,
  iconClassName = "bg-g-600",
  valueClassName,
  trend,
  trendDirection,
  className,
  ...props
}) {
  return (
    <div
      className={cn("flex flex-col gap-2.5 rounded-ds-lg border border-line bg-surface p-[18px]", className)}
      {...props}
    >
      <div className="flex items-center justify-between gap-3">
        <span
          className={cn(
            "font-display text-[1.85rem] font-extrabold leading-none tracking-[-0.02em]",
            valueClassName
          )}
        >
          {value}
        </span>

        {icon && (
          <span
            className={cn(
              "grid h-[42px] w-[42px] shrink-0 place-items-center rounded-[11px] text-white",
              iconClassName
            )}
          >
            {icon}
          </span>
        )}
      </div>

      {caption && <span className="text-[13px] text-ink-400">{caption}</span>}

      {trend && (
        <span
          className={cn(
            "inline-flex items-center gap-1 text-xs font-semibold",
            trendDirection === "down" ? "text-danger" : "text-success"
          )}
        >
          {trend}
        </span>
      )}
    </div>
  );
}
